<template>
<div>
  <v-breadcrumbs>
      <v-icon slot="divider">chevron_right</v-icon>
      <v-breadcrumbs-item
        v-for="(breadcrumb, idx) in breadcrumbList "
        :key="idx"
        @click.native="routeTo(idx)"
        :class="{'linked': !!breadcrumb.link}"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>


  </div>
    
</template>


<script>
import TokenComponent from "../Token";
import { readJSON, daLiJeVinarija } from "./../../helpers/Functions";

export default {
  name: "Breadcrumbs",
  data() {
    return {
      breadcrumbList: [],
      vinarija: true
    };
  },
  components: {
      TokenComponent
    },
  mounted () {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    this.updateList(this.$route.name, this.$route.params.id, this.$route.params.name_wine_type);
  },
  methods: {
    routeTo(pRouteTo){
      if(this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link);
    },
    updateList (stranica, id, wine_type_name) {
      // alert(id);

    if (id !== undefined)
      this.breadcrumbList = this.$route.meta.breadcrumb

      if (stranica === "tank_room")
        this.getRoomNameFirst(id);
      else if (stranica === "empty_tank")
        this.getRoomEmptyTank(id);
      else if (stranica === "single_tank")
        this.getRoomSingleTank(id);
      else if (stranica === "single_vineyard")
        this.getRoomSingleVineYard(id);
      else if (stranica === "warehouse_type")
        this.getRoomSingleWareHouseList(id);
      else if (stranica === "ware_house_list")
        this.getRoomSingleWareHouse(id);
      else if (stranica === "wine_type"){
        if (typeof wine_type_name !== "undefined")
          this.breadcrumbList[1].name = wine_type_name;
        else
          this.getWineTypeName(id)
      }
      else if (stranica === "wine_year"){
        this.getWineYearNames(id)
      }
      else if (stranica === "single_wine"){
        this.getSingleWine(id)
      }
    },
    getRoomNameFirst(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/tank_phase_wine/room/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
						this.items = response.data;
						if (this.items.length > 0){
this.breadcrumbList[1].name = response.data[0].roomName;
            }
						else
							this.getRoomName(id);
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/tank_phase_wine/room/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
						this.items = response.data;
						if (this.items.length > 0){
this.breadcrumbList[1].name = response.data[0].roomName;
            }
						else
							this.getRoomName(id);
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
			},
			getRoomName(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/room/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
						this.breadcrumbList[1].name = response.data.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/room/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
						this.breadcrumbList[1].name = response.data.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
			getWineTypeName(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/wine_label/wine_type/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            // // console.log(response.data[0].wineType.name);

						this.breadcrumbList[1].name = response.data[0].wineType.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/wine_label/wine_type/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            // // console.log(response.data[0].wineType.name);

						this.breadcrumbList[1].name = response.data[0].wineType.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
			getWineYearNames(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/wine/wine_label/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            this.breadcrumbList[1].name = response.data.wineLabel.wineType.name;
            
            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/wine_type/" + response.data.wineLabel.wineType.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.wineLabel.wineType.id;


            this.breadcrumbList[2].name = response.data.wineLabel.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/wine/wine_label/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            this.breadcrumbList[1].name = response.data.wineLabel.wineType.name;
            
            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/wine_type/" + response.data.wineLabel.wineType.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.wineLabel.wineType.id;


            this.breadcrumbList[2].name = response.data.wineLabel.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
			getSingleWine(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/wine/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            this.breadcrumbList[1].name = response.data.wineLabel.wineType.name;
            
            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/wine_type/" + response.data.wineLabel.wineType.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.wineLabel.wineType.id;

            this.breadcrumbList[2].name = response.data.wineLabel.name;
            
            var n1 = this.breadcrumbList[2].link.indexOf("/", 2);

            if (n1 === -1)
              this.breadcrumbList[2].link = this.breadcrumbList[2].link + "/wine_year/" + response.data.wineLabel.id;
            else
              this.breadcrumbList[2].link = this.breadcrumbList[2].link.substring(0, n1) + "/" + response.data.wineLabel.id;

            this.breadcrumbList[3].name = response.data.year;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/wine/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            this.breadcrumbList[1].name = response.data.wineLabel.wineType.name;
            
            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/wine_type/" + response.data.wineLabel.wineType.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.wineLabel.wineType.id;

            this.breadcrumbList[2].name = response.data.wineLabel.name;
            
            var n1 = this.breadcrumbList[2].link.indexOf("/", 2);

            if (n1 === -1)
              this.breadcrumbList[2].link = this.breadcrumbList[2].link + "/wine_year/" + response.data.wineLabel.id;
            else
              this.breadcrumbList[2].link = this.breadcrumbList[2].link.substring(0, n1) + "/" + response.data.wineLabel.id;

            this.breadcrumbList[3].name = response.data.year;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
      getRoomEmptyTank(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/tank/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            this.breadcrumbList[1].name = response.data.room.name;

            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.room.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.room.id;

            this.breadcrumbList[2].name = response.data.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/tank/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            this.breadcrumbList[1].name = response.data.room.name;

            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.room.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.room.id;

            this.breadcrumbList[2].name = response.data.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
      getRoomSingleTank(id) {
				this.$http
					.get(
						this.globalServiceLocation + this.globalPort + "/tank_phase_wine/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
					)
					.then(response => {
						this.breadcrumbList[1].name = response.data.tank.room.name;

            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.tank.room.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.tank.room.id;

            this.breadcrumbList[2].name = response.data.tank.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(
						this.globalServiceLocation + this.globalPort + "/tank_phase_wine/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
					)
					.then(response => {
						this.breadcrumbList[1].name = response.data.tank.room.name;

            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.tank.room.id;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.tank.room.id;

            this.breadcrumbList[2].name = response.data.tank.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
      getRoomSingleVineYard(id) {
				this.$http
					.get(
						this.globalServiceLocation + this.globalPort + "/vineyard/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
					)
					.then(response => {

            if(this.vinarija)
              this.breadcrumbList[0].name = "Pregled vinograda";
            else
              this.breadcrumbList[0].name = "Pregled zasada";

						this.breadcrumbList[1].name = response.data.name;

					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(
						this.globalServiceLocation + this.globalPort + "/vineyard/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
					)
					.then(response => {
						this.breadcrumbList[1].name = response.data.name;

            // var n = this.breadcrumbList[1].link.indexOf("/", 2);

            // if (n === -1)
            //   this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.id;
            // else
            //   this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.id;

            // this.breadcrumbList[2].name = ""; // response.data.tank.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
      },
      getRoomSingleWareHouse(id) {
				this.$http
					.get(
						this.globalServiceLocation + this.globalPort + "/warehouse/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
					)
					.then(response => {
						this.breadcrumbList[1].name = response.data.warehouseType.name;

            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.warehouseType.id + "/" + response.data.warehouseType.name;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.warehouseType.id + "/" + response.data.warehouseType.name;

            this.breadcrumbList[2].name = response.data.name; // response.data.tank.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(
						this.globalServiceLocation + this.globalPort + "/warehouse/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
					)
					.then(response => {
						this.breadcrumbList[1].name = response.data.name;

            var n = this.breadcrumbList[1].link.indexOf("/", 2);

            if (n === -1)
              this.breadcrumbList[1].link = this.breadcrumbList[1].link + "/" + response.data.id + "/" + response.data.name;
            else
              this.breadcrumbList[1].link = this.breadcrumbList[1].link.substring(0, n) + "/" + response.data.id + "/" + response.data.name;

            this.breadcrumbList[2].name = response.name; // response.data.tank.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
			},
      getRoomSingleWareHouseList(id) {
				this.$http
					.get(this.globalServiceLocation + this.globalPort + "/warehouse_type/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            console.log(response.data);

						this.breadcrumbList[1].name = response.data.name; // response.data[0].wineType.name;
					})
					.catch(e => {
						if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
					.get(this.globalServiceLocation + this.globalPort + "/warehouse_type/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
					.then(response => {
            // // console.log(response.data[0].wineType.name);

						this.breadcrumbList[1].name = response.data.name; // response.data[0].wineType.name;
					})
					.catch(e => {
						// // console.log(e.message);
						alert(1);
						// alert(this.$lang.general.greskaNaServeru);
					});
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
					});
			}
  },
  watch: {
			$route() {
        this.updateList(this.$route.name, this.$route.params.id, this.$route.params.name_wine_type);
			}
		}
};
</script>
<style lang="scss" scoped>
.v-breadcrumbs {
  padding: 0;
  padding-bottom: 10px;
}
</style>
